import React from 'react';
import { Container, Card, Button, Alert } from 'react-bootstrap';
import { IconLock, IconCreditCard, IconHome } from '@tabler/icons-react';

/**
 * Tela exibida quando usuário com acesso restrito tenta acessar uma rota não permitida.
 * Informa sobre a situação do plano e oferece opções de navegação.
 */
const RestrictedAccessScreen = ({ reason, allowedRoutes = [] }) => {
  const messages = {
    expired: {
      title: "Plano Expirado",
      description: "Seu plano expirou e você não tem acesso a esta funcionalidade.",
      icon: "error",
      badgeText: "Plano Expirado",
      badgeVariant: "danger"
    },
    suspended: {
      title: "Plano Suspenso",
      description: "Seu plano está suspenso por falta de pagamento.",
      icon: "warning",
      badgeText: "Plano Suspenso",
      badgeVariant: "warning"
    },
    canceled: {
      title: "Plano Cancelado",
      description: "Seu plano foi cancelado e você não tem acesso a esta funcionalidade.",
      icon: "error",
      badgeText: "Plano Cancelado",
      badgeVariant: "danger"
    },
    no_plan: {
      title: "Sem Plano Ativo",
      description: "Você não possui um plano ativo para acessar esta funcionalidade.",
      icon: "info",
      badgeText: "Sem Plano",
      badgeVariant: "secondary"
    }
  };

  const config = messages[reason] || messages.no_plan;

  return (
    <Container className="mt-5">
      <div className="row justify-content-center">
        <div className="col-lg-8 col-xl-6">
          <Card className="border-warning shadow-sm">
            <Card.Body className="text-center p-5">
              <div
                className="mx-auto mb-4 d-flex align-items-center justify-content-center"
                style={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '50%',
                  backgroundColor: 'rgba(255, 193, 7, 0.1)'
                }}
              >
                <IconLock size={48} className="text-warning" />
              </div>

              <h3 className="text-warning mb-3">{config.title}</h3>

              <p className="text-muted mb-4">
                {config.description}
                <br />
                Para acessar esta funcionalidade, regularize sua situacao.
              </p>

              <Alert variant="warning" className="mb-4">
                <div className="d-flex justify-content-between align-items-center">
                  <span><strong>Status da Conta:</strong></span>
                  <span className={`badge bg-${config.badgeVariant}`}>
                    {config.badgeText}
                  </span>
                </div>
              </Alert>

              <div className="d-flex justify-content-center gap-3 flex-wrap">
                <Button
                  variant="primary"
                  size="lg"
                  onClick={() => window.location.href = '/my-plan'}
                  className="d-flex align-items-center gap-2"
                >
                  <IconCreditCard size={20} />
                  Regularizar Pagamento
                </Button>
                <Button
                  variant="outline-secondary"
                  size="lg"
                  onClick={() => window.location.href = '/'}
                  className="d-flex align-items-center gap-2"
                >
                  <IconHome size={20} />
                  Voltar ao Inicio
                </Button>
              </div>

              {allowedRoutes.length > 0 && (
                <div className="mt-4 pt-4 border-top">
                  <small className="text-muted">
                    <strong>Paginas disponiveis:</strong>{' '}
                    {allowedRoutes.map((route, index) => (
                      <span key={route}>
                        <a href={route} className="text-primary">
                          {route === '/' ? 'Dashboard' : route.replace('/', '').charAt(0).toUpperCase() + route.slice(2)}
                        </a>
                        {index < allowedRoutes.length - 1 && ' | '}
                      </span>
                    ))}
                  </small>
                </div>
              )}
            </Card.Body>
          </Card>
        </div>
      </div>
    </Container>
  );
};

export default RestrictedAccessScreen;
